import { GridItem } from '@chakra-ui/react';
import { ListRow } from 'components/molecules/ListRow';
import { TextWithTooltip } from 'components/molecules/TextWithTooltip/TextWithTooltip';
import { FC } from 'react';
import { ReleaseTask } from 'types/releaseTask';
import { convertUTCStringIntoJSTString, DATE_FORMAT } from 'utils/dateUtils';

type Props = {
  /** リリースコンポーネント */
  item: ReleaseTask;
  /** 行クリックイベントのハンドラ */
  handleClickRow: () => void;
};

export const TaskListItem: FC<Props> = ({ item, handleClickRow }) => (
  <ListRow
    onClick={handleClickRow}
    templateColumns="minmax(0, 1fr) minmax(0, 3fr) minmax(0, 2fr) minmax(0, 2fr) minmax(0, 2fr)"
  >
    <GridItem w="100%">
      <TextWithTooltip
        text={item.taskName}
        visibleTooltip
        tooltipMaxWidth="200px"
      />
    </GridItem>
    <GridItem w="100%">
      <TextWithTooltip
        text={item.manifestVersion || ''}
        visibleTooltip
        tooltipMaxWidth="600px"
      />
    </GridItem>
    <GridItem w="100%">
      <TextWithTooltip
        text={convertUTCStringIntoJSTString(
          item.startsAt,
          DATE_FORMAT.DATE_TIME,
        )}
        visibleTooltip
        tooltipMaxWidth="200px"
      />
    </GridItem>
    <GridItem w="100%">
      <TextWithTooltip
        text={convertUTCStringIntoJSTString(item.endsAt, DATE_FORMAT.DATE_TIME)}
        visibleTooltip
        tooltipMaxWidth="200px"
      />
    </GridItem>
    <GridItem w="100%">
      <TextWithTooltip
        text={item.group}
        visibleTooltip
        tooltipMaxWidth="200px"
      />
    </GridItem>
  </ListRow>
);
